import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './FAQPage.css';

const FAQ_DATA = [
  {
    q: 'What is the CodeHub Project Internship?',
    a: 'The CodeHub Project Internship is a guided project-based learning program where students work on real-world development projects through our web platform. The internship is designed to help students gain practical coding experience and improve their development skills.',
  },
  {
    q: 'Who can enroll in the internship?',
    a: 'Any student, beginner developer, or programming enthusiast who wants to gain practical experience in software development can enroll in the internship or learning module on the CodeHub platform.',
  },
  {
    q: 'How do I enroll in a project internship?',
    a: 'You can enroll by:\n1. Creating an account on CodeHub\n2. Selecting the internship project you want to work on\n3. Agreeing to the internship terms and conditions\n4. Completing the payment and confirming your enrollment',
  },
  {
    q: 'Can I enroll in more than one project internship?',
    a: 'No. Students are allowed to enroll in only one project at a time during the internship.',
  },
  {
    q: 'Can I change my project after enrolling?',
    a: 'No. Once your project enrollment is confirmed, it cannot be changed. Please review the project details carefully before enrolling.',
  },
  {
    q: 'How is the internship structured?',
    a: 'Each internship project is divided into multiple stages or modules. Students must complete each stage sequentially and submit their work for review.',
  },
  {
    q: 'How are project submissions evaluated?',
    a: 'All submissions are reviewed by the CodeHub review team. If the work does not meet the required standards, students may be asked to revise and resubmit their work.',
  },
  {
    q: 'Will I receive mentor support during the internship?',
    a: 'Yes. If you face difficulties during project setup, coding, or implementation, you can use the Support section on the platform to request mentor assistance.',
  },
  {
    q: 'What kind of help can mentors provide?',
    a: 'Mentors can help with:\n• Project setup guidance\n• Understanding project requirements\n• Debugging issues\n• Implementation guidance\n\nHowever, students are expected to complete the project work themselves.',
  },
  {
    q: 'What happens if I do not complete the project?',
    a: 'Students who do not complete all required stages or fail to submit their project within the internship duration may not receive the internship completion certificate.',
  },
  {
    q: 'Will I receive a certificate after completing the internship?',
    a: 'Yes. Students who successfully complete all project stages and pass the evaluation process will receive an internship completion certificate.',
  },
  {
    q: 'Are the internship resources accessible to everyone?',
    a: 'No. Internship materials, project documentation, and resources are available only to enrolled students and must not be shared publicly.',
  },
  {
    q: 'What payment methods are accepted?',
    a: 'Payments can be made using UPI, debit cards, credit cards, net banking, and other supported online payment methods through our secure payment gateway.',
  },
  {
    q: 'Is the internship fee refundable?',
    a: 'No. All payments made for internship enrollment are non-refundable and cannot be canceled once the enrollment is confirmed.',
  },
  {
    q: 'How can I contact support if I have questions?',
    a: 'You can contact our support team through the Support section on the platform or email us at support@batosit.com.',
  },
];

const FAQItem = ({ item, isOpen, onToggle }) => (
  <div className={`faq-item ${isOpen ? 'faq-item--open' : ''}`}>
    <button className="faq-question" onClick={onToggle}>
      <span>{item.q}</span>
      <svg className={`faq-chevron ${isOpen ? 'faq-chevron--open' : ''}`} width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </button>
    {isOpen && (
      <div className="faq-answer">
        {item.a.split('\n').map((line, i) => (
          <p key={i}>{line}</p>
        ))}
      </div>
    )}
  </div>
);

const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="faq-page">
      <div className="faq-container">

        <Link to="/" className="faq-back-link">← Back to Home</Link>

        <div className="faq-header">
          <span className="faq-eyebrow">Support</span>
          <h1 className="faq-title">Frequently Asked Questions</h1>
          <p className="faq-subtitle">
            Everything you need to know about the CodeHub internship program.
            Can't find what you're looking for? <a href="mailto:support@batosit.com">Contact us</a>.
          </p>
        </div>

        <div className="faq-list">
          {FAQ_DATA.map((item, i) => (
            <FAQItem
              key={i}
              item={item}
              isOpen={openIndex === i}
              onToggle={() => setOpenIndex(openIndex === i ? null : i)}
            />
          ))}
        </div>

        <div className="faq-cta">
          <h3>Still have questions?</h3>
          <p>Our support team is here to help you.</p>
          <a href="mailto:support@batosit.com" className="faq-cta-btn">
            ✉️ Email Us
          </a>
        </div>

      </div>
    </div>
  );
};

export default FAQPage;
